import { Button, Card, Empty, Typography } from "antd";
import { formatElapsed } from "../turnListHelpers";

const { Text, Title } = Typography;

export default function CurrentTurnCard({
  current,
  elapsedNow,
  onSale,
  onNoSale,
  onRegisterLater,
  onSkip,
  busy,
}) {
  if (!current) {
    return (
      <Card>
        <Empty description="Ninguém na fila. Marque alguém como disponível na equipe do dia." />
      </Card>
    );
  }

  const initial = (current.seller_name || "?").trim().charAt(0).toUpperCase();

  return (
    <Card>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
        }}>
        <Text type="secondary" style={{ letterSpacing: 1 }}>
          NA VEZ
        </Text>
        <Text type="secondary">
          há {formatElapsed(current.since, elapsedNow)}
        </Text>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 20,
          margin: "16px 0 24px",
        }}>
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            background: "var(--ouran-card-header-bg)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 32,
            fontWeight: 600,
            flexShrink: 0,
          }}>
          {initial}
        </div>
        <div>
          <Title level={2} style={{ margin: 0, lineHeight: 1.1 }}>
            {current.seller_name}
          </Title>
          <Text type="secondary">
            {current.attendances} atendimentos · {current.sales} vendas
          </Text>
        </div>
      </div>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <Button
          type="primary"
          size="large"
          loading={busy}
          style={{ height: 56, minWidth: 160, fontSize: 18 }}
          onClick={onSale}>
          Vendeu
        </Button>
        <Button
          danger
          size="large"
          disabled={busy}
          style={{ height: 56, minWidth: 160, fontSize: 18 }}
          onClick={onNoSale}>
          Não vendeu
        </Button>
        <Button
          size="large"
          disabled={busy}
          style={{ height: 56, minWidth: 140 }}
          onClick={onRegisterLater}>
          Registrar Depois
        </Button>
        <Button
          size="large"
          disabled={busy}
          style={{ height: 56, minWidth: 140 }}
          onClick={onSkip}>
          Passar a vez
        </Button>
      </div>
    </Card>
  );
}
